import Primary from "../layouts/Primary";
import './Award.scss';
import './Advancement.css';
import {t} from "../../i18n";
import ScrollingText from "../components/ScrollingText";
import MiniOverlay from "../layouts/MiniOverlay";
import {CommonAdvancement as AdvancementType, DisplayCommand, ShowAdvancement} from "../../javaTypes";
import {DisplayConfig} from "../Config";
import {useAsset} from "../../AssetHelper";

const statusMap = {
    FIRST: "",
    ALREADY_ADVANCING: t`Already Advancing`,
    ADVANCING_ABOVE: t`Advancing Above`,
    INELIGIBLE: t`Ineligible`,
    NULL: ""
}
const getBracketText = (adv : EnrichedAdvancement) => {
    if (adv.team > 0 && adv.status === 'FIRST') {
        return ' #' + adv.number + "";
    }
    return statusMap[adv.status];
}

interface EnrichedAdvancement extends AdvancementType {
    slot: number,
    number: number,
}

function AdvancementList({advancements, index}: {
    advancements: EnrichedAdvancement[],
    index: number
    }) {
    const shown = advancements.slice(index > 3 ? index - 3 : 0, index + 1);
    return <div>
        {shown.map((advancement) =>
                <div className={`awardSeries`} key={advancement.slot}>
                    <div className={"awardTeamAvatar"}>
                        <div className={`team-avatar team-${advancement.team}`}></div>
                    </div>
                    <div className={"awardTeamInfo"}>
                        <div className={"awardTeam"}>
                            <span className={"teamNumber"}>{advancement.team > 0 ? advancement.team : ""}</span>
                            <span className={"teamName"}>
                                <ScrollingText width={"1135px"}>
                                    {advancement.teamName ? advancement.teamName  : ""}
                                </ScrollingText>
                            </span>
                        </div>
                        <div className={"d-flex justify-content-between"}>
                        <div className={"teamLocation"}>{getBracketText(advancement)}</div>
                        </div>
                    </div>
                </div>)}
    </div>;
}

export default function Advancement({command, config}: {
    command: DisplayCommand<ShowAdvancement>,
    config: DisplayConfig
}) {
    const programLogo = useAsset("img/logos/ftc_horiz_reverse.svg")

    let advancingTo = command.params.config.advancesTo;
    let advancementCount = command.params.config.advancementCount;
    let reserveCount = command.params.config.reserveCount;
    let reservedHtmlString = reserveCount > 0 ? t`(${command.params.config.reserveCount} reserved for ${"<i>FIRST</i>"} Championship)`: "";
    const wantOverlay = config.overlay && config.awardsStyle === 'overlay';
    const advancements: EnrichedAdvancement[] = [];
    // fill the 2 numbers shown
    let count = 1;
    for (let i = 0; i < command.params.list.length; i++) {
        const adv = Object.assign({slot: i + 1, number: count}, command.params.list[i]);
        advancements.push(adv)
        if (adv.team > 0 && adv.status === 'FIRST') {
            count++;
        }
    }
    if (wantOverlay) {
        if (command.params.index < 0) {
            let advancingCount = t`Advancing ${advancementCount} teams`;
            let advancingContent = <div className={"advancementTargetWrapper"}>
                <span style={{}}>{t`Advancing to:`}</span>
                <span className={"advancementTarget"}><ScrollingText>{advancingTo ? advancingTo : ""}</ScrollingText></span>
            </div>
            if (command.params.config.isExtraRegional) {
                advancingCount = t`${advancementCount} total teams ${reservedHtmlString}`
                advancingContent = <div dangerouslySetInnerHTML={{__html: "Advancing to <i>FIRST</i> Championship & Premier Events"}}/>
            }
            return <MiniOverlay config={config} header={advancingCount} type={"advancement"}>
                <div className={`awardSeries`}>
                    {advancingContent}
                </div>
            </MiniOverlay>
        } else {
            let advancement = advancements[command.params.index];
            const advancementText = getBracketText(advancement);
            return <MiniOverlay config={config} header={t`Advancement - ${advancementText}`} type={"advancement"}>
                {advancement ? <div className={`awardSeries`}>
                    <div className={"awardTeamAvatar"}>
                        <div className={`team-avatar team-${advancement.team}`}></div>
                    </div>
                    <div className={"awardTeamInfo"}>
                        <div className={"awardTeam"}>
                            <span>{advancement.team > 0 ? `${advancement.displayTeam}` : ""}</span><br/>
                            <span className={"teamName"}>
                                <ScrollingText>
                                    {advancement.team > 0 ? `${advancement.teamName}` : ''}
                                </ScrollingText>
                            </span>
                        </div>
                    </div>
                </div> : null}
            </MiniOverlay>
        }
    } else {
        return <Primary>
            <div className={`awardIntro ${reserveCount > 0 ? "reserveSlots" : ""}`}>
                {programLogo ? <div className={"programLogoWrapper"}>
                    <img className="programLogo" src={programLogo}/>
                </div> : null}
                {command.params.config.isExtraRegional ? <div style={{textAlign: 'left'}}>
                        <div dangerouslySetInnerHTML={{__html: t`Advancing to ${"<i>FIRST</i> Championship"} & Premier Events`}}/>
                        <div dangerouslySetInnerHTML={{__html: t`${advancementCount} total teams ${reservedHtmlString}`}}/>
                    </div> : <ScrollingText>{advancingTo ? t`Advancing to ${advancingTo} (${advancementCount} Teams)` : ""}</ScrollingText>}

            </div>
            {<AdvancementList advancements={advancements} index={command.params.index}/>}
        </Primary>;
    }
}